/* tslint:disable:jsx-no-lambda */
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Masthead } from '@ta-interaktiv/react-masthead'
// @ts-ignore
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import { HorizontalNavigation } from 'components/horizontalNavigation'
import { Intro } from 'components/intro'
import { Placeholder } from 'components/placeholder'
import { QuestProgress } from 'components/questProgress'
import { VerticalSegment } from 'components/verticalSegment'
import React, { Component, lazy, Suspense } from 'react'
import { hot } from 'react-hot-loader/root'
import { Redirect, Route, Switch } from 'react-router-dom'
import { animated, Transition } from 'react-spring/renderprops'
import questions from './questions.yml'
import './styles.scss'
import { ScrollToTopOnMount } from 'components/scrollToTop'
import { Waypoint } from 'react-waypoint'
import { Cover } from 'components/cover'

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    project: {
      version: string
      buildTimestamp: number
    }
    dataLayer: { event: string; event_action?: string; event_label?: string }[]
  }
}

const ARTICLE_ID = '109932202307'

const Methodik = lazy(() =>
  import(/* webpackChunkName: "methodik" */ 'components/methodik')
)

const Footer = lazy(() =>
  import(/* webpackChunkName: "footer" */ 'components/footer')
)

const Question = lazy(() => import('components/question'))

const Demographics = lazy(() =>
  import(/* webpackChunkName: "results" */ 'components/demographics')
)

const Results = lazy(() =>
  import(/* webpackChunkName: "results" */ 'components/results')
)

const UserFeedback = lazy(() =>
  import(/* webpackChunkName: "footer" */ '@ta-interaktiv/react-user-feedback')
)

interface IState {
  publishedTimestamp?: number
  transitionState: 'animating' | 'resting'
}

class AppComponent extends Component<{}, IState> {
  private constructor(props: {}) {
    super(props)

    this.state = { transitionState: 'resting' }
  }

  public componentDidMount(): void {
    const domain = parseHostname()

    window
      .fetch(`https://m.${domain.publicationDomain}/api/articles/${ARTICLE_ID}`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(`${response.status}: ${response.statusText}`)
      })
      .then(data => {
        this.setState({ publishedTimestamp: data.article.first_published_at })
      })
      .catch(e => {
        // tslint:disable-next-line
        console.groupCollapsed('Main')
        // tslint:disable-next-line
        console.warn('API Access failed: ', e)
        // tslint:disable-next-line
        console.groupEnd()
      })
  }

  public render() {
    const fromCSS: React.CSSProperties = {
      opacity: 0,
      position: 'absolute',
      transform: 'translateX(250px)'
    }
    const enterCSS: React.CSSProperties = {
      opacity: 1,
      position: 'relative',
      transform: 'translateX(0px)'
    }
    const leaveCSS: React.CSSProperties = {
      opacity: 0,
      position: 'absolute',
      transform: 'translateX(-250px)'
    }
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={ARTICLE_ID} />

        <Cover
          onLeave={event => {
            if (
              event.previousPosition === Waypoint.inside &&
              event.currentPosition === Waypoint.above
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'startReading'
              })
            }
          }}
        />

        <VerticalSegment text={true}>
          <Intro />
        </VerticalSegment>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: '20ContentRead'
              })
            }
          }}
        />

        <QuestProgress />

        <VerticalSegment className='grey infographic quiz-container'>
          <div style={{ position: 'relative', zIndex: 10 }}>
            <HorizontalNavigation>
              <Suspense fallback={<Placeholder />}>
                <Route
                  render={({ location }) => (
                    <Transition
                      native={true}
                      items={location}
                      keys={location.key}
                      from={fromCSS}
                      enter={enterCSS}
                      leave={leaveCSS}
                      onStart={() =>
                        this.setState({ transitionState: 'animating' })
                      }
                      onRest={() =>
                        this.setState({ transitionState: 'resting' })
                      }
                    >
                      {(loc, state) => style => (
                        <Switch location={state === 'update' ? location : loc}>
                          <Redirect
                            from={'/'}
                            exact={true}
                            to={'/question/1'}
                          />
                          <Route
                            path={'/question/:questionNumber'}
                            render={props => (
                              <animated.div style={style}>
                                <Question
                                  {...props}
                                  questionIndex={
                                    parseInt(
                                      props.match.params.questionNumber,
                                      10
                                    ) - 1
                                  }
                                  {...questions[
                                    props.match.params.questionNumber - 1
                                  ]}
                                />
                              </animated.div>
                            )}
                          />
                          <Route
                            path={'/demographics'}
                            render={() => (
                              <animated.div style={style}>
                                <Demographics />
                              </animated.div>
                            )}
                          />
                          <Route
                            path={'/results'}
                            render={() => (
                              <animated.div style={style}>
                                <ScrollToTopOnMount />
                                <Results
                                  transitionState={this.state.transitionState}
                                />
                                <Suspense fallback={<Placeholder />}>
                                  <div className='ui text container'>
                                    {' '}
                                    <UserFeedback
                                      articleId={ARTICLE_ID}
                                      starColor={'purple'}
                                      questions={[
                                        'Wie unterhaltsam war das Quiz?',
                                        'Funktionierte die technische Umsetzung?'
                                      ]}
                                    />
                                  </div>
                                </Suspense>
                              </animated.div>
                            )}
                          />
                        </Switch>
                      )}
                    </Transition>
                  )}
                />
              </Suspense>
            </HorizontalNavigation>
          </div>
        </VerticalSegment>

        <VerticalSegment
          text={true}
          id={'methodik'}
          className='purple secondary'
        >
          <Suspense fallback={<Placeholder />}>
            <Methodik
              components={{
                h3: (
                  props: JSX.IntrinsicAttributes &
                    React.ClassAttributes<HTMLHeadingElement> &
                    React.HTMLAttributes<HTMLHeadingElement>
                ) => (
                  <h3
                    className={'ui purple small infographic header'}
                    {...props}
                  />
                )
              }}
            />
          </Suspense>
        </VerticalSegment>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />

        <Suspense fallback={<Placeholder />}>
          <Footer
            articleId={ARTICLE_ID}
            publicationDate={
              (this.state && this.state.publishedTimestamp) ||
              window.project.buildTimestamp
            }
          />
        </Suspense>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot(AppComponent)
